import script from "./PauseFinalChanceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PauseFinalChanceModal.vue?vue&type=script&setup=true&lang=ts"

import "./PauseFinalChanceModal.vue?vue&type=style&index=0&id=7d6d3e89&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6d3e89"]])

export default __exports__